/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Source_HintInputs */

const cs_templates_source_hint = /** @type {(inputs: Templates_Source_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj je uložený v databázi. Upload slouží k importu.`)
};

const en_templates_source_hint = /** @type {(inputs: Templates_Source_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source is stored in the database. Upload still works for import.`)
};

/**
* | output |
* | --- |
* | "Source is stored in the database. Upload still works for import." |
*
* @param {Templates_Source_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_source_hint = /** @type {((inputs?: Templates_Source_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Source_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_source_hint(inputs)
	return cs_templates_source_hint(inputs)
});